module.exports = __webpack_public_path__ + "media/post-listing-block-4-overlay@2x.15e59fd9.png";